import { CookieAuth } from './client/auth';
import { ApiClientClass } from './client';

export const ApiClient = new ApiClientClass(CookieAuth());
